import { CAPACITY_PER_PRODUCTION_BUILDING, coordEq } from "@dailywars/core/engine";

import { COORDS, ownUnitAt } from "./tutorialStepHelpers";
import type { TutorialStep } from "./tutorialStepTypes";

const { sniperBarracks, factory } = COORDS;

export const tutorialIntro: TutorialStep = {
  id: "tutorial-intro",
  dismissible: true,
  buildKind: null,
  enableEndTurn: false,
  prompt: () => ({
    title: "Tutorial",
    body: "This tutorial will teach you the basics of Daily Wars: building units, capturing properties, and combat.",
    highlight: null,
    dismissible: true,
  }),
  allowsTile: () => false,
  isComplete: () => false,
};

export const buildRifleman: TutorialStep = {
  id: "build-rifleman",
  buildKind: "rifleman",
  enableEndTurn: false,
  prompt: (mode) =>
    mode === "building"
      ? {
          title: "Build a Rifleman",
          body: "Pick the Rifleman. You'll send it to capture the neutral city.",
          highlight: null,
        }
      : {
          title: "Build a Rifleman",
          body: "Tap your highlighted barracks to open its build menu.",
          highlight: { kind: "tile", coord: sniperBarracks },
        },
  allowsTile: (_store, tile) => coordEq(tile, sniperBarracks),
  isComplete: (store) => ownUnitAt(store.localState, { coord: sniperBarracks, kind: "rifleman" }),
};

export const buildSniper: TutorialStep = {
  id: "build-sniper",
  buildKind: "sniper",
  enableEndTurn: false,
  prompt: (mode) =>
    mode === "building"
      ? {
          title: "Build a Sniper",
          body: "Pick the Sniper. It strikes from 2 tiles away and never takes a counterattack.",
          highlight: null,
        }
      : {
          title: "Build a Sniper",
          body: "Your barracks is free again. Tap it and build a Sniper.",
          highlight: { kind: "tile", coord: sniperBarracks },
        },
  allowsTile: (_store, tile) => coordEq(tile, sniperBarracks),
  isComplete: (store) => ownUnitAt(store.localState, { coord: sniperBarracks, kind: "sniper" }),
};

export const buildLightTank: TutorialStep = {
  id: "build-light-tank",
  buildKind: "lightTank",
  enableEndTurn: false,
  prompt: (mode) =>
    mode === "building"
      ? {
          title: "Build a Light Tank",
          body: "Factories build vehicles. Pick the Light Tank for a strong direct attack.",
          highlight: null,
        }
      : {
          title: "Build from your factory",
          body: "Tap the highlighted factory and build a Light Tank.",
          highlight: { kind: "tile", coord: factory },
        },
  allowsTile: (_store, tile) => coordEq(tile, factory),
  isComplete: (store) => ownUnitAt(store.localState, { coord: factory, kind: "lightTank" }),
};

export const capacityInfo: TutorialStep = {
  id: "capacity-info",
  dismissible: true,
  buildKind: null,
  enableEndTurn: false,
  prompt: () => ({
    title: "Capacity",
    body: `Each production building adds ${CAPACITY_PER_PRODUCTION_BUILDING} capacity for its unit type(s). You can't build more units when at max capacity.`,
    highlight: null,
    dismissible: true,
    showCapacity: "all",
  }),
  allowsTile: () => false,
  isComplete: () => false,
};

export const incomeInfo: TutorialStep = {
  id: "income-info",
  dismissible: true,
  buildKind: null,
  enableEndTurn: false,
  prompt: () => ({
    title: "Income",
    body: "Most buildings generate 100 funds at the start of each turn. Capture properties to grow your income.",
    highlight: null,
    dismissible: true,
    showIncome: true,
  }),
  allowsTile: () => false,
  isComplete: () => false,
};
